// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"LecturerSection_sectionWrapper__AjH1K"};